import React, { useState, useContext } from "react";
import "./ALL3DServices.scss";
import { Tabs, Row, Col, Card, Modal, Button, Carousel, Select, Collapse, Layout } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import Slider from "react-slick"
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { PORTAL_BASE_URL } from "../../../env";
import ModelViewer from "../../landingPage/sectionTwo/modelViewer";
const { Content } = Layout;

const services = [
    {
        'img': '/smb/service_2.png',
        'title': 'Product images on white backgrounds with professional angles and lighting',
        'desc': 'Our product image tool takes the 3D model and spins up multiple angles of your product at 4k resolution.'
    },
    {
        'img': '/smb/service_1.png',
        'title': 'Lifestyle images that showcase your product’s scale and intended use',
        'desc': 'We provide a variety of scene templates to place your products and easily generate photorealistic lifestyle images.'
    },
    {
        'img': '/smb/service_3.png',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/28795_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/static_files/hero_section_assets/28795.glb",
        'title': '3D players to see every product detail',
        'desc': 'Customers can view every detail of your product with a 360 spin or by grabbing the product and spinning it around to see every angle.'
    },
    {
        'img': '/smb/service_4.png',
        'title': 'Immersive View in Room experiences with AR models',
        'desc': 'Customers see a 9% improvement in sales on average when View in Room is available on a product listing.'
    },
    {
        'img': '/smb/service_5.png',
        'title': 'New! Unlimited AI images',
        'stacked': true,
        'beta': true,
        'desc': 'Generate AI images in minutes created from a single product photo and a prompt.'
    }
]
const services_text = [
    {
        'title': 'Photorealistic models ready for ecommerce',
    },
    {
        'title': 'Product and lifestyle images',
    },
    {
        'title': 'Unlimited AI images',
        'beta': true
    },
    {
        'title': 'AR view in room',
    },
    {
        'title': '3D player & API integration',
    },
    {
        'title': 'Sharing & cloud storage',
    },
]
const ALL3DServices = () => {

    return (<>
        <WebVersion />
        <MobileVersion />
    </>)
}

const WebVersion = () => {
    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid justify-in-center services-section">
                <Col span={24} className="justify-in-center text-center">
                    <p className="manrope f-16 lh-24 w-700 black-085">ALL3D Services & Features</p>
                </Col>
                <Col span={24} className="justify-in-center text-center">
                    <h3 className="manrope f-38 lh-46 w-600 black-085 mb-16">We cover all the bases (and then some) <div>to make your listings shine.</div></h3>
                </Col>
                <Col span={24} className="justify-in-center text-center">
                    <h3 className="manrope f-16 lh-24 w-500 black-085 mb-64">
                        From photorealistic models and product images to immersive 3D players and AR, we provide easy-to-use <div>services for you to sell more products.</div>
                    </h3>
                </Col>
                {services.map((service, index) => (
                    index == (services.length - 1) ?
                        <Col span={24} className="justify-space-between direction-flex pd-40-20 gap-40">
                            <img src={service.img} />
                            <div className="w-100">
                                <p className="manrope f-20 w-700 lh-28 black-085 mb-8 text-left">{service.title}
                                    {service.beta &&
                                        <span className="beta-bg-tag ml-8">BETA</span>}
                                </p>
                                <p className="manrope f-16 w-400 lh-24 black-085 text-left">{service.desc}</p>
                            </div>
                        </Col> :
                        <Col span={12} className="direction-flex coll pd-40-20">
                            {service.model ?
                                <div className="service-model-container mb-24">
                                    <ModelViewer class='service-model'
                                        poster={service.poster}
                                        src={service.src}
                                    />
                                </div>
                                : <img src={service.img} className="mb-24" />}
                            <p className="manrope f-20 w-700 lh-28 black-085 mb-8 text-left">{service.title}</p>
                            <p className="manrope f-16 w-400 lh-24 black-085 text-left">{service.desc}</p>
                        </Col>
                ))}

                <Col span={24} className="j-sb-a-start direction-flex service-border mt-40 mb-64">
                    <Col span={14}>
                        <h3 className="manrope f-24 w-700 black-085 text-left">Flexible pricing based on your needs</h3>
                        <h4 className="manrope f-16 w-700 black-085 text-left">Subscriptions and packages starting at $139/product</h4>
                    </Col>
                    <Col span={10} className="services">
                        <p className="manrope f-14 black-085 w-700">With 3D services such as:</p>

                        <ul>
                            {services_text.map((text, i) => (
                                <li key={i} className="justify-space-between">
                                    <div className="justify-in-start-align-baseline">
                                        <CheckOutlined className="manrope blue w-700 mr-10" />
                                        <span className="manrope f-14 black-085 w-500 lh-22">{text.title}</span>
                                        {text.beta &&
                                            <span className="beta-bg-tag ml-8">BETA</span>}
                                    </div>

                                </li>
                            ))}
                        </ul>
                    </Col>
                </Col>
                <Col span={24} className="justify-in-center direction-flex">
                    <Button onClick={() =>
                        window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent("/select-subscription?plan=free_trial&plan_type=smb_services")}`, "_blank")
                    }
                        className={`manrope f-16 w-700 lh-24 blue-button`}
                    >
                        Get started for free
                    </Button>
                    <Button onClick={() => {
                        window.location.href = '/pricing'
                    }}
                        className={`manrope f-16 w-700 lh-24 white-button-black-border ml-16`}
                    >
                        View pricing & plans
                    </Button>
                </Col>
            </Row>
        </Content>
    );
}

const MobileVersion = () => {

    const settings = {
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1.07,
        slidesToScroll: 1,
        vertical: false,
        customPaging: i => (
            <div className="custom-dot">
                {/* &ndash;  This is the dash */}
            </div>
        ),
    };

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid justify-in-start services-section">
                <Col span={24} className="justify-in-start text-left pdlr-16">
                    <p className="manrope f-16 lh-24 w-700 black-085 mb-16">ALL3D Services & Features</p>
                </Col>
                <Col span={24} className="justify-in-start text-left pdlr-16">
                    <h3 className="manrope f-30 lh-40 w-600 black-085 mb-16">We cover all the bases (and then some) to make your listings shine.</h3>
                </Col>
                <Col span={24} className="justify-in-start text-left pdlr-16">
                    <h3 className="manrope f-16 lh-24 w-500 black-085 mb-35">
                        From photorealistic models and product images to immersive 3D players and AR, we provide easy-to-use services for you to sell more products.
                    </h3>
                </Col>
                <Col span={24} className="pdl-16">
                    <Slider {...settings} className="services-card">
                        {services.map((service, index) => (
                            <div className="card-wrapper card-padding" key={index}>
                                {service.model ?
                                <div className="service-model-container mb-24">
                                    <ModelViewer class='service-model'
                                        poster={service.poster}
                                        src={service.src}
                                    />
                                </div> :
                                <img src={service.img} className={`services-img ${service.stacked ? `ai` : ``} mb-24`} />}
                                <p className="manrope f-24 w-700 lh-32 black-085 mb-8 text-left">
                                    {service.title}
                                </p>
                                <p className="manrope f-14 w-500 lh-22 black-085 text-left">{service.desc}</p>
                            </div>
                        ))}
                    </Slider>
                </Col>

                <Col span={24} className="pdlr-16">
                    <Button onClick={() =>
                        window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent("/select-subscription?plan=free_trial&plan_type=smb_services")}`, "_blank")
                    }
                        className={`manrope f-16 w-700 lh-24 blue-button mb-16 w-100 centerCarousel`}
                        block>
                        Get started for free
                    </Button>
                </Col>
                <Col span={24} className="pdlr-16">
                    <Button onClick={() => {
                        window.location.href = '/pricing'
                    }}
                        className={`manrope f-16 w-700 lh-24 white-button-black-border w-100 centerCarousel`}
                        block>
                        View pricing & plans
                    </Button>
                </Col>
            </Row>
        </Content>
    );
}

export default ALL3DServices;
